import config from 'react-global-configuration'

const fragment = window.location.search;
const queryParams = fragment.split('?')[1];
const params = new URLSearchParams(queryParams);
const camp = params.get("camp");
const rcid = params.get("rcid");
console.log("camp and rcid", camp, rcid)

if(camp && rcid){
    localStorage.setItem("cbinfo","saved")
}
else{
    localStorage.setItem("cbinfo","na")
}

config.set({
    ga_tag: "",
    ga_debug: false,
    base:"https://telecubesapis.bngrenew.com/apn",
    elastic_base_url:"https://serviceusagesv1.bngrenew.com/publish",
    domain : "btc",
    he : "/he",
    subscribe: '/subscribe',
    requestOTP: "/requestOTP",
    activate: "/activate",
    checkSub: "/checkSub",
    unsubscribe : '/unsubscribe',
    userPacks : '/userPacks',
    appConfig : '/config' , 
    getPacks: "/getPacks",
    headers: {
        'Reqfrom': 'web',
        'Username': 'web',
        'Servicefor':'https://telid.cubegames.live',
        'Language' : localStorage.getItem("lang") || 'id',
    }
})

export const getHeaders = () => {
    const headers = { ...config.get("headers") };  // Get existing headers
    headers["w_req_url"] = window.location.href;
    headers["camp"] = camp || sessionStorage.getItem("camp") || localStorage.getItem("camp") || "";
    headers["rcid"] = rcid || sessionStorage.getItem("rcid") || localStorage.getItem("rcid") || "";
    headers["mtype"] = localStorage.getItem("mtype") || "nonhe";  /* only non he flow */
    headers["blocked"] = localStorage.getItem("blocked") || 0;     /* no blocklist */
    headers["breason"] = localStorage.getItem("breason") || "";
    return headers;    //return updated headers
};


export default config